import { render, staticRenderFns } from "./CreateNoteBtn.vue?vue&type=template&id=5faaaad0&"
import script from "./CreateNoteBtn.vue?vue&type=script&lang=ts&"
export * from "./CreateNoteBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports